import { render, staticRenderFns } from "./CafeList.vue?vue&type=template&id=1bf8962e"
import script from "./CafeList.vue?vue&type=script&lang=js"
export * from "./CafeList.vue?vue&type=script&lang=js"
import style0 from "./CafeList.vue?vue&type=style&index=0&id=1bf8962e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports